import { ObjectHelpers } from "../../helpers/object-helpers";

export class HighChartDataPoints {
    public points: Array<any> = [];
    public zones: Array<any> = [];

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}